import { useState } from 'react';
import { Avatar, Box, Flex, Text, useBreakpointValue } from '@chakra-ui/react';

import { useAuth } from '../../hooks/auth';
import Button from '../../components/Button';

import { AnimationContainer, Container, Content } from './styles';
import ModalConfirmDelete from './ModalConfirmDelete';

const DeleteAccount: React.FC = () => {
	const { userPintor10, signOutPintor10 } = useAuth();

	const [modalConfirmDeleteVisible, setModalConfirmDeleteVisible] = useState(false);

	return (
		<>
			<Container>
				<Content>
					<AnimationContainer>
						<Flex
							flex={1}
							w="100%"
							pb={2}
							flexDir="column"
							borderWidth={2} borderColor="blue.500"
							borderRadius={10}
						>
							<Box w="100%" h={100} background="blue.500"></Box>

							<Flex flexDir="column" justifyContent="center" align="center">
								<Avatar size='2xl' name={userPintor10.nome}
									mt={-20}
									src={
										userPintor10.avatar_url
											? userPintor10.avatar_url
											: 'https://safetycloud.blob.core.windows.net/cashback-promocoes/placeholder-image.png'
									}
								/>

							
								<Text fontSize="md" fontWeight={500}>{userPintor10.nome}</Text>
								<Text fontSize="md" fontWeight={500}>{userPintor10.email}</Text>

								<Flex flexDir="column" w="100%" px={2} mt={2}>
									<Text fontSize="md" fontWeight={500} color="gray.600">Documentos</Text>
									{userPintor10.doc && 
										<Text fontSize="md" fontWeight={500} ml={2}>CPF: {userPintor10.doc}</Text>
									}
									{userPintor10.rg && 
										<Text fontSize="md" fontWeight={500} ml={2}>RG: {userPintor10.rg}</Text>
									}
								</Flex>

								{userPintor10.telefones.length > 0 && (
									<Flex flexDir="column" w="100%" px={2} mt={2}>
										<Text fontSize="md" fontWeight={500} color="gray.600">Telefones</Text>
										{userPintor10.telefones.map(telefone => (
											<Flex key={telefone.id} flexDir="column" p={2} ml={2} mb={1}
												borderWidth={1} borderColor="gray.100" borderRadius={10}
											>
												<Text fontSize="md" fontWeight={500}>{telefone.numero}</Text>
												{telefone.obs && 
													<Text fontSize="md" fontWeight={500}>Obs.: {telefone.obs}</Text>
												}
											</Flex>
										))
									}
									</Flex>
								)}
							</Flex>
						</Flex>

						<Button
							style={{ background: "#B71C1C" }}
							onClick={() => setModalConfirmDeleteVisible(true)}
						>
							Deletar Conta
						</Button>

						<Button onClick={signOutPintor10}>Sair</Button>
					</AnimationContainer>
				</Content>
			</Container>

			{modalConfirmDeleteVisible && (
				<ModalConfirmDelete
					isOpen={modalConfirmDeleteVisible}
					onRequestClose={() => setModalConfirmDeleteVisible(false)}
				/>
			)}
		</>
	)
}

export default DeleteAccount;